// It is important to have these constants defined in the same file.
// Since each dispatched action will call each reducer, this prevents action type naming collisions.
// TODO: Migrate to Redux Toolkit, then redesign these actions per Redux best practices:
//       - Actions should represent events.
//         (https://redux.js.org/tutorials/fundamentals/part-3-state-actions-reducers#designing-actions)
//       - Reducers should be responsible for the main shape, not the callers themselves.
//         (https://redux.js.org/style-guide/#put-as-much-logic-as-possible-in-reducers)
enum ActionTypeEnum {
    // ------------------------- [ Addresses ] -------------------------
    ADDRESS_SET = "ADDRESS_SET",
    ADDRESS_ADD = "ADDRESS_ADD",
    ADDRESS_UPDATE = "ADDRESS_UPDATE",

    // ------------------------- [ App ] -------------------------
    APP_IS_LOADING_SET = "APP_IS_LOADING_SET",
    APP_HAS_BOOTSTRAP_LOADED_SET = "APP_HAS_BOOTSTRAP_LOADED_SET",
    APP_MESSAGES_SET = "APP_MESSAGES_SET",
    APP_MESSAGES_ADD = "APP_MESSAGES_ADD",

    // ------------------------- [ Auth ] -------------------------
    AUTH_LOGIN_BOOTSTRAP_SET = "AUTH_LOGIN_BOOTSTRAP_SET",

    // ------------------------- [ Cart ] -------------------------
    CART_SET = "CART_SET",
    CART_CLEAR = "CART_CLEAR",
    CART_CUSTOMER_EMAIL_SET = "CART_CUSTOMER_EMAIL_SET",
    CART_PREFERENCES_SET = "CART_PREFERENCES_SET",
    CART_PREFERENCES_SET_PARTIALLY = "CART_PREFERENCES_SET_PARTIALLY",

    // ------------------------- [ Cart - Addresses ] -------------------------
    CART_ADDRESS_SHIPPING_SET = "CART_ADDRESS_SHIPPING_SET",
    CART_ADDRESS_BILLING_SET = "CART_ADDRESS_BILLING_SET",

    // ------------------------- [ Cart - Shipping Quotes ] -------------------------
    SHIPPING_QUOTES_SET = "SHIPPING_QUOTES_SET",

    // ------------------------- [ Cart - Payment ] -------------------------
    PAYMENT_GATEWAY_SET = "PAYMENT_GATEWAY_SET",
    PAYMENT_TOKENIZED_SET = "PAYMENT_TOKENIZED_SET",
    PAYMENT_TOKENIZED_ADD = "PAYMENT_TOKENIZED_ADD",
    PAYMENT_TOKENIZED_REMOVE = "PAYMENT_TOKENIZED_REMOVE",
    PAYMENT_TOKENIZED_SET_SELECTED = "PAYMENT_TOKENIZED_SET_SELECTED",
    PAYMENT_DEVICE_DATA_SET = "PAYMENT_DEVICE_DATA_SET",
    PAYMENT_DO_SAVE_SET = "PAYMENT_DO_SAVE_SET",
    PAYMENT_ERROR_SET = "PAYMENT_ERROR_SET",

    // ------------------------- [ Client Data ] -------------------------
    CLIENT_DATA_SET = "CLIENT_DATA_SET",

    // ------------------------- [ Order ] -------------------------
    ORDER_RESULT_SET = "ORDER_RESULT_SET",

    // ------------------------- [ Pre Upsells ] -------------------------
    UPSELLS_SET = "UPSELLS_SET",

    // ------------------------- [ Post Upsells ] -------------------------
    POST_UPSELL_PRODUCTS_ADDED = "POST_UPSELL_PRODUCTS_ADDED",
    POST_UPSELL_PRODUCTS_REMOVED = "POST_UPSELL_PRODUCTS_REMOVED",
    POST_UPSELL_ORDER_PLACED = "POST_UPSELL_ORDER_PLACED",
}

export default ActionTypeEnum;
